import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Form, Input, Button, Typography, Alert, Space } from 'antd';
import { LockOutlined, ReadOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';

const { Title, Text } = Typography;

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async ({ token }: { token: string }) => {
    setLoading(true);
    setError(null);
    const ok = await login(token.trim());
    setLoading(false);
    if (ok) {
      navigate('/courses');
    } else {
      setError('Invalid admin token — server returned an error. Check your credentials and try again.');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1677ff 0%, #0958d9 50%, #003eb3 100%)',
      }}
    >
      <div style={{ width: 420, padding: '0 16px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 64,
              height: 64,
              borderRadius: 16,
              background: 'rgba(255,255,255,0.15)',
              marginBottom: 16,
              backdropFilter: 'blur(8px)',
            }}
          >
            <ReadOutlined style={{ fontSize: 32, color: '#fff' }} />
          </div>
          <Title level={2} style={{ color: '#fff', margin: 0 }}>
            BePrime Admin
          </Title>
          <Text style={{ color: 'rgba(255,255,255,0.75)', fontSize: 15 }}>
            Sign in with your admin token
          </Text>
        </div>

        <Card
          style={{
            borderRadius: 16,
            boxShadow: '0 24px 64px rgba(0,0,0,0.3)',
            border: 'none',
          }}
          styles={{ body: { padding: '32px 32px 24px' } }}
        >
          <Space direction="vertical" size={20} style={{ width: '100%' }}>
            {error && <Alert type="error" message={error} showIcon />}

            <Form onFinish={handleSubmit} layout="vertical" requiredMark={false}>
              <Form.Item
                name="token"
                label="Admin Token"
                rules={[{ required: true, message: 'Please enter your admin token' }]}
              >
                <Input.Password
                  prefix={<LockOutlined style={{ color: '#bfbfbf' }} />}
                  placeholder="Paste your admin token here"
                  size="large"
                  autoFocus
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  loading={loading}
                  block
                  style={{ height: 46, fontSize: 15 }}
                >
                  Sign In
                </Button>
              </Form.Item>
            </Form>
          </Space>
        </Card>
      </div>
    </div>
  );
};

export default LoginPage;
